import AbstractTemplateManager from "./templateManager";
import generatePath from "./generatePath";
import { cssGlobalFilenameSuffix, cssTabletFilenameSuffix, cssMobileFilenameSuffix } from "../../../config/fileSuffixes";
import createTemplate from "./createTemplate";
import { definedPages } from "../../../config/defaults";

class ReleaseTemplateManager extends AbstractTemplateManager {
    constructor() {
        super();
        this.maxFileSize = 164000;

        this.cssGlobal = new Map();
        this.scssGlobal = new Map();

        this.cssTablet = new Map();
        this.scssTablet = new Map();

        this.cssMobile = new Map();
        this.scssMobile = new Map();

        this.layoutPreloadJsInclude  = ['<link rel="preload" href="js/js.min.js?v={{ lqTS }}" as="script">',
                                        '<link rel="preload" href="js/init-ui1.min.js?v={{ lqTS }}" as="script">',
                                        '<link rel="preload" href="js/init-ui2.min.js?v={{ lqTS }}" as="script">'];
        this.layoutJsInclude = [`<script src="js/js.min.js?v={{ lqTS }}"></script>`,
            `<script src="js/init-ui1.min.js?v={{ lqTS }}"></script>`,
            `<script src="js/init-ui2.min.js?v={{ lqTS }}"></script>`
        ];

        this.layoutMinJs = "";
        this.minJsContents = new Map();

        this.layoutCssGlobal = "";
        this.importPathScssGlobal = "";

        this.layoutCssTablet = "";
        this.importPathScssTablet = "";

        this.layoutCssMobile = "";
        this.importPathScssMobile = "";

        this.layoutPreloadCssInclude = {
            global: [`<link rel="preload" href="css/desktop1.css?v={{ lqTS }}" as="style">`,
                                        `<link rel="preload" href="css/desktop2.css?v={{ lqTS }}" as="style">`,
                                        `<link rel="preload" href="css/offline.css?v={{ lqTS }}" as="style">`,
                                        `{% if page.PageId == config.DefinedPages.Order.Id -%}
    <link rel="preload" href="css/collection-points.css?v={{ lqTS }}" as="style">
{% endif -%}`],
            tablet: [],
            mobile: [`<link rel="preload" href="css/mobile.css?v={{ lqTS }}" media="(max-width: 1279px)" as="style">`]
        };

        this.layoutCssGlobalInclude = [`<link rel="stylesheet" href="css/desktop1.css?v={{ lqTS }}" type="text/css">`,
                                        `<link rel="stylesheet" href="css/desktop2.css?v={{ lqTS }}" type="text/css">`,
                                        `<link rel="stylesheet" href="css/offline.css?v={{ lqTS }}" type="text/css">`,
                                        `{% if page.PageId == config.DefinedPages.Order.Id -%}
    <link rel="stylesheet" href="css/collection-points.css?v={{ lqTS }}" type="text/css">
{% endif -%}`];
        this.layoutCssTabletInclude = [];
        this.layoutCssMobileInclude = [`<link rel="stylesheet" href="css/mobile.css?v={{ lqTS }}" media="(max-width: 1279px)" type="text/css">`];
    }

    generateCssTemplate([locationPrefix, location], templateObject, cssFilenameSuffix, [cssField, scssField], cssMap, scssMap, layoutCss) {
        let cssPrefix = "css";
        if (!!locationPrefix) {
            cssPrefix = "css/" + locationPrefix;
        }
        const fullPathCSS = generatePath(cssPrefix, location, templateObject.id || "", "css", cssFilenameSuffix);
        const importFullPathSCSS = '@import "../' + fullPathCSS.slice(4).replace('css', 'scss') + '";';
        const cssContent = templateObject[cssField] || "";
        if (!cssContent) {
            return;
        }
        if (this.cssJsPaths.has(fullPathCSS)) {
            return;
        }

        if (location === "header") {
            this.headerLocations[cssField] = cssContent;
            this.headerLocations[scssField] = importFullPathSCSS;
            this.cssJsPaths.add(fullPathCSS);
            return;
        }
        if (location === "footer") {
            this.footerLocations[cssField] = cssContent;
            this.footerLocations[scssField] = importFullPathSCSS;
            this.cssJsPaths.add(fullPathCSS);
            return;
        }

        if (templateObject.pages) {
            this.settingDefinedPagesCssJsContent(templateObject, cssMap, cssContent);      
            this.settingDefinedPagesCssJsContent(templateObject, scssMap, importFullPathSCSS + "\n");      
            this.cssJsPaths.add(fullPathCSS);
            return;
        }

        const cssContent1 = this.getMapContent(cssMap, 'Content1');
        const cssContent2 = this.getMapContent(cssMap, 'Content2');
        const cssContent3 = this.getMapContent(cssMap, 'Content3');

        const css = layoutCss + (this.headerLocations[cssField] || "") + (this.footerLocations[cssField] || "") + cssContent1 + cssContent2 + cssContent3;
        const newCssSize = css.length + cssContent.length;

        if (newCssSize > this.maxFileSize) {
            if ((cssContent2.length + cssContent.length) > this.maxFileSize) {
                this.settingCssJsContentsMap(cssMap, 'Content3', cssContent);
                this.settingCssJsContentsMap(scssMap, 'Content3', importFullPathSCSS + "\n");
            } else {
                this.settingCssJsContentsMap(cssMap, 'Content2', cssContent);
                this.settingCssJsContentsMap(scssMap, 'Content2', importFullPathSCSS + "\n");
            }
        } else {
            this.settingCssJsContentsMap(cssMap, 'Content1', cssContent);
            this.settingCssJsContentsMap(scssMap, 'Content1', importFullPathSCSS + "\n");
        }
        this.cssJsPaths.add(fullPathCSS);
    }

    generateJsAndMinJsTemplate(locationPrefix, location, templateObject) {
        let jsPrefix = "js";
        if (!!locationPrefix) {
            jsPrefix = "js/" + locationPrefix;
        }
        const fullPathJS = generatePath(jsPrefix, location, templateObject.id || "", "js");
        const jsContent = templateObject.js || "";
        const minJsContent = templateObject.minJs || templateObject.js || "";
        if (!minJsContent) {
            return;
        }
        if (this.cssJsPaths.has(fullPathJS)) {
            return;
        }
        
        if (location === "header") {
            this.headerLocations.minJs = minJsContent;
            this.headerLocations.js = jsContent;
            this.cssJsPaths.add(fullPathJS);
            return;
        }
        if (location === "footer") {
            this.footerLocations.minJs = minJsContent;
            this.footerLocations.js = jsContent;
            this.cssJsPaths.add(fullPathJS);
            return;
        }

        if (templateObject.pages) {
            this.settingDefinedPagesCssJsContent(templateObject, this.minJsContents, minJsContent);      
            this.settingDefinedPagesCssJsContent(templateObject, this.jsContents, jsContent);  
            this.cssJsPaths.add(fullPathJS);
            return;
        }

        const minJsContent1 = this.getMapContent(this.minJsContents, 'Content1');
        const minJsContent2 = this.getMapContent(this.minJsContents, 'Content2');

        const minJs = this.layoutMinJs + (this.headerLocations.minJs || "") + (this.footerLocations.minJs || "") + minJsContent1;
        const newJsSize = minJs.length + minJsContent.length;

        if (newJsSize > this.maxFileSize) {
            if ((minJsContent2.length + minJsContent.length) > this.maxFileSize) {
                this.settingCssJsContentsMap(this.minJsContents, 'Content3', minJsContent);
                this.settingCssJsContentsMap(this.jsContents, 'Content3', jsContent);
            } else {
                this.settingCssJsContentsMap(this.minJsContents, 'Content2', minJsContent);
                this.settingCssJsContentsMap(this.jsContents, 'Content2', jsContent);
            }
        } else {
            this.settingCssJsContentsMap(this.minJsContents, 'Content1', minJsContent);
            this.settingCssJsContentsMap(this.jsContents, 'Content1', jsContent);
        }
        this.cssJsPaths.add(fullPathJS);
    }

    generateLayoutJsAndMinJsTemplate(abstractFileVersion = '') {
        const minScripts = [this.layoutMinJs, 
                           this.headerLocations.minJs || "", 
                           this.footerLocations.minJs || "",
                           this.minJsContents.get('Content1') || "",
                           this.minJsContents.get('Content2') || "",
                           this.minJsContents.get('Content3') || ""
        ];
        const scripts = [this.layoutJs, 
                        this.headerLocations.js || "", 
                        this.footerLocations.js || "",
                        this.jsContents.get('Content1') || "",
                        this.jsContents.get('Content2') || "",
                        this.jsContents.get('Content3') || ""
        ];
        const filesArr = new Map();
        let baseFilesArr = [["", "", "", ""], ["", "", "", ""]];
        for(let i = 0; i < scripts.length; i++){
            baseFilesArr = this.assignScriptToFile(minScripts[i], scripts[i], baseFilesArr);
        }
        filesArr.set("", baseFilesArr);
        this.minJsContents.forEach((minJsValue, minJsKey) => {
            if (minJsKey !== "Content1" && minJsKey !== "Content2" && minJsKey !== "Content3") {
                let pageFilesArr = [["", "", "", ""], ["", "", "", ""]];
                pageFilesArr = this.assignScriptToFile(minJsValue, this.jsContents.get(minJsKey) || "", pageFilesArr);
                filesArr.set(minJsKey, pageFilesArr);
            }
        });
        const layoutJsIncludeTemp = [];
        const preloadLayoutJsIncludeTemp = [];
        filesArr.forEach((fileArray, fileSubName) => {
            for(let i = 0; i < fileArray[0].length; i++) {
                if(fileArray[0][i].length > 0) {
                    let pathSubName = fileSubName;
                    if (fileSubName) {
                        pathSubName = `-${fileSubName.toLowerCase()}`;
                    }
                    const path = 'js/layout' + pathSubName + i + '.min.js';
                    this.templates.set(path, createTemplate(path, fileArray[0][i]));
                    const userPath = 'js/layout' + pathSubName + i + '.js';
                    this.templates.set(userPath, createTemplate(userPath, fileArray[1][i]));
                    let includeJsString = '<script src="' + path + '?v=' + abstractFileVersion + '_{{ lqTS }}"></script>';
                    let includePreloadJsString = '<link rel="preload" href="' + path + '?v=' + abstractFileVersion + '_{{ lqTS }}" as="script">';
                    if (fileSubName) {
                        includeJsString = `{% if page.PageId == ${definedPages[fileSubName]} -%}\n` + includeJsString + '\n{% endif -%}';
                        includePreloadJsString = `{% if page.PageId == ${definedPages[fileSubName]} -%}\n` + includePreloadJsString + '\n{% endif -%}';
                    }
                    layoutJsIncludeTemp.push(includeJsString);
                    preloadLayoutJsIncludeTemp.push(includePreloadJsString);
                }
            }
            if (!fileSubName) {
                layoutJsIncludeTemp.push(...this.layoutJsInclude);
                preloadLayoutJsIncludeTemp.push(...this.layoutPreloadJsInclude);
            }

        });
        this.layoutJsInclude = [...layoutJsIncludeTemp];
        this.layoutPreloadJsInclude = [...preloadLayoutJsIncludeTemp];
    }

    generateStaticFiles(spinner) {
        const staticFiles = require("../../../assets/staticFiles").default;
        staticFiles.forEach(file => {
            this.processStaticFile(file);
        })
        //file to generate depends on spinnerIcon
        let spinnerText;
        if (spinner.style && spinner.icon) {
            spinnerText = require(`../../../assets/staticFiles/css/img/b64_spinner/b64_${spinner.icon}-${spinner.style}.gif`).default;
        } else {
            spinnerText = require("../../../assets/staticFiles/css/img/b64_alo.gif").default;
        }
        this.processStaticFile({
            "name": "css/img/alo.gif",
            "encoded": true,
            "text": spinnerText
        });
    }

    getBaseLayout() {
        const baseLayoutObject = require("../../../assets/layout").default;
        const baseLayoutPath = baseLayoutObject.path;
        this.generateHtmlTemplate("", baseLayoutPath, baseLayoutObject);
        this.generateScssTemplate("", baseLayoutPath, baseLayoutObject, cssGlobalFilenameSuffix, "scss");
        this.generateScssTemplate("", baseLayoutPath, baseLayoutObject, cssTabletFilenameSuffix, "scssTablet");
        this.generateScssTemplate("", baseLayoutPath, baseLayoutObject, cssMobileFilenameSuffix, "scssMobile");
        this.layoutCssGlobal = baseLayoutObject.css;
        this.layoutCssTablet = baseLayoutObject.cssTablet;
        this.layoutCssMobile = baseLayoutObject.cssMobile;
        this.layoutJs = baseLayoutObject.js;
        this.layoutMinJs = baseLayoutObject.minJs || baseLayoutObject.js || "";
        this.importPathScssGlobal = '@import "../' + baseLayoutPath + cssGlobalFilenameSuffix + '.scss";';
        this.importPathScssTablet = '@import "../' + baseLayoutPath + cssTabletFilenameSuffix + '.scss";';
        this.importPathScssMobile = '@import "../' + baseLayoutPath + cssMobileFilenameSuffix + '.scss";';
    }

    //locationPrefix - used to denote origin in template path, ie. staticElements,elements, partials
    //location - path to file (can be a whole subbranch)
    //templateObject - required/imported object with html,css,scss,js fields specified
    generateObjectTemplate(locationPrefix, location, templateObject) {
        //paths are going to be different with different types of objects
        //partials should be detected only in html
        this.generateHtmlTemplate(locationPrefix, location, templateObject);
        this.generateCssTemplate([locationPrefix, location], 
                                 templateObject, 
                                 cssGlobalFilenameSuffix, 
                                 ["css", "importPathScss"], 
                                 this.cssGlobal, 
                                 this.scssGlobal, 
                                 this.layoutCssGlobal
        );
        this.generateCssTemplate([locationPrefix, location],
                                 templateObject,
                                 cssMobileFilenameSuffix,
                                 ["cssMobile", "importPathScssMobile"],
                                 this.cssMobile,
                                 this.scssMobile,
                                 this.layoutCssMobile
        );
        this.generateCssTemplate([locationPrefix, location],
                                 templateObject,
                                 cssTabletFilenameSuffix,
                                 ["cssTablet", "importPathScssTablet"],
                                 this.cssTablet,
                                 this.scssTablet,
                                 this.layoutCssTablet
        );
        this.generateScssTemplate(locationPrefix, location, templateObject, cssGlobalFilenameSuffix, "scss");
        this.generateScssTemplate(locationPrefix, location, templateObject, cssTabletFilenameSuffix, "scssTablet");
        this.generateScssTemplate(locationPrefix, location, templateObject, cssMobileFilenameSuffix, "scssMobile");
        this.generateJsAndMinJsTemplate(locationPrefix, location, templateObject);
        this.generateRelatedPartials(templateObject.relatedPartials);
    }

    generateLayoutCSSTemplate([layoutCss, layoutScss], [cssField, scssField], cssMap, scssMap, [abstractFileVersion, fileNameSuffix, additionalLinkSettings], layoutPreloadCssInclude, layoutCssInclude) {
        const css = [layoutCss, 
                     this.headerLocations[cssField] || "", 
                     this.footerLocations[cssField] || "", 
                     cssMap.get("Content1") || "", 
                     cssMap.get("Content2") || "", 
                     cssMap.get("Content3") || ""];
        const scssPath = [layoutScss, 
                          this.headerLocations[scssField] || "", 
                          this.footerLocations[scssField] || "", 
                          scssMap.get("Content1") || "", 
                          scssMap.get("Content2") || "", 
                          scssMap.get("Content3") || ""];
        const filesArr = new Map();
        let baseFilesArr = [["", "", "", ""], ["", "", "", ""]];
        for(let i = 0; i < css.length; i++){
            baseFilesArr = this.assignCssToFile(css[i], scssPath[i], baseFilesArr);
        }
        filesArr.set("", baseFilesArr);
        cssMap.forEach((cssValue, cssKey) => {
            if (cssKey !== "Content1" && cssKey !== "Content2" && cssKey !== "Content3") {
                let pageFilesArr = [["", "", "", ""], ["", "", "", ""]];
                pageFilesArr = this.assignCssToFile(cssValue, scssMap.get(cssKey) || "", pageFilesArr);
                filesArr.set(cssKey, pageFilesArr);
            }
        });
        filesArr.forEach((fileArray, fileSubName) => {
            for(let i = 0; i < fileArray[0].length; i++){
                if(fileArray[0][i].length > 0){
                    let pathSubName;
                    if (fileSubName) {
                        pathSubName = `-${fileSubName.toLowerCase()}${fileNameSuffix}`;
                    } else {
                        pathSubName = fileSubName + fileNameSuffix;
                    }
                    const path = 'css/layout/layout' + pathSubName + i + '.css';
                    this.templates.set(path, createTemplate(path, fileArray[0][i]));
                    const userPath = 'scss/layout/layout' + pathSubName + i + '.scss';
                    this.templates.set(userPath, createTemplate(userPath, fileArray[1][i]));
                    const templateName = path + '?v=' + abstractFileVersion + '_{{ lqTS }}';
                    const linkSettings = additionalLinkSettings || '';
                    let includePreloadCSSString = `<link rel="preload" href="${templateName}" ${linkSettings} as="style">`;
                    let includeCSSString = `<link rel="stylesheet" href="${templateName}" ${linkSettings}>`;
                    if (fileSubName) {
                        includePreloadCSSString = `{% if page.PageId == ${definedPages[fileSubName]} -%}\n` + includePreloadCSSString + '\n{% endif -%}';
                        includeCSSString = `{% if page.PageId == ${definedPages[fileSubName]} -%}\n` + includeCSSString + '\n{% endif -%}';
                    }
                    layoutPreloadCssInclude.push(includePreloadCSSString);
                    layoutCssInclude.push(includeCSSString);
                }
            }
        });
    }

    assignCssToFile(css, scssPath, filesArr) {
        let css0 = filesArr[0][0];
        let css1 = filesArr[0][1];
        let css2 = filesArr[0][2];
        let css3 = filesArr[0][3];

        let scssPath0 = filesArr[1][0];
        let scssPath1 = filesArr[1][1];
        let scssPath2 = filesArr[1][2];
        let scssPath3 = filesArr[1][3];
        if(css.length > 0){
            if ((css0.length + css.length) > this.maxFileSize) {
                if ((css1.length + css.length) > this.maxFileSize) {
                    if((css2.length + css.length) > this.maxFileSize) {
                        css3 += css;
                        scssPath3 += scssPath + "\n";
                    } else {
                        css2 += css;
                        scssPath2 += scssPath + "\n";
                    }
                } else {
                    css1 += css;
                    scssPath1 += scssPath + "\n";
                }
            } else {
                css0 += css;
                scssPath0 += scssPath + "\n";
            }
        }
        return [[css0, css1, css2, css3], [scssPath0, scssPath1, scssPath2, scssPath3]];
    }

    assignScriptToFile(minScript, script, filesArr) {
        let minJs0 = filesArr[0][0];
        let minJs1 = filesArr[0][1];
        let minJs2 = filesArr[0][2];
        let minJs3 = filesArr[0][3];

        let js0 = filesArr[1][0];
        let js1 = filesArr[1][1];
        let js2 = filesArr[1][2];
        let js3 = filesArr[1][3];
        if(script.length > 0){
            if ((minJs0.length + minScript.length) > this.maxFileSize) {
                if ((minJs1.length + minScript.length) > this.maxFileSize) {
                    if ((minJs2.length + minScript.length) > this.maxFileSize) {
                        minJs3 += minScript;
                        js3 += script;
                    } else {
                        minJs2 += minScript;
                        js2 += script;
                    }
                } else {
                    minJs1 += minScript;
                    js1 += script;
                }
            } else {
                minJs0 += minScript;
                js0 += script;
            }
        }
        return [[minJs0, minJs1, minJs2, minJs3], [js0, js1, js2, js3]];
    }

    generateLayoutTemplates(fontName="Roboto") {
        const today = new Date();
        const options = { year: 'numeric', month: '2-digit', day: '2-digit'};
        const abstractFileVersion = today.toLocaleDateString(undefined, options) + '_' + today.toLocaleTimeString();
        const regexPattern = /\?v=.*?{{ lqTS }}/;
        const replaceVersion = '?v=' + abstractFileVersion + '_{{ lqTS }}'

        for (let i=0; i<this.layoutPreloadJsInclude.length; i++) {
            this.layoutPreloadJsInclude[i] = this.layoutPreloadJsInclude[i].replace(regexPattern, replaceVersion);
        }
        for(let i=0; i<this.layoutJsInclude.length; i++){
            this.layoutJsInclude[i] = this.layoutJsInclude[i].replace(regexPattern, replaceVersion);
        }
        for (let i=0; i<this.layoutPreloadCssInclude.global.length; i++) {
            this.layoutPreloadCssInclude.global[i] = this.layoutPreloadCssInclude.global[i].replace(regexPattern, replaceVersion);
        }
        for (let i=0; i<this.layoutPreloadCssInclude.tablet.length; i++) {
            this.layoutPreloadCssInclude.tablet[i] = this.layoutPreloadCssInclude.tablet[i].replace(regexPattern, replaceVersion);
        }
        for (let i=0; i<this.layoutPreloadCssInclude.mobile.length; i++) {
            this.layoutPreloadCssInclude.mobile[i] = this.layoutPreloadCssInclude.mobile[i].replace(regexPattern, replaceVersion);
        }
        for(let i=0; i<this.layoutCssGlobalInclude.length; i++){
            this.layoutCssGlobalInclude[i] = this.layoutCssGlobalInclude[i].replace(regexPattern, replaceVersion);
        }
        for(let i=0; i<this.layoutCssTabletInclude.length; i++){
            this.layoutCssTabletInclude[i] = this.layoutCssTabletInclude[i].replace(regexPattern, replaceVersion);
        }
        for(let i=0; i<this.layoutCssMobileInclude.length; i++){
            this.layoutCssMobileInclude[i] = this.layoutCssMobileInclude[i].replace(regexPattern, replaceVersion);
        }

        this.generateLayoutJsAndMinJsTemplate(abstractFileVersion);
        this.generateLayoutCSSTemplate([this.layoutCssGlobal, this.importPathScssGlobal], 
                                       ["css", "importPathScss"], 
                                       this.cssGlobal, 
                                       this.scssGlobal, 
                                       [abstractFileVersion, "", null], 
                                       this.layoutPreloadCssInclude.global, 
                                       this.layoutCssGlobalInclude
        );
        this.generateLayoutCSSTemplate([this.layoutCssTablet, this.importPathScssTablet],
                                       ["cssTablet", "importPathScssTablet"],
                                       this.cssTablet,
                                       this.scssTablet,
                                       [abstractFileVersion, cssTabletFilenameSuffix, 'media="screen and (min-width: 768px) and (max-width: 1439px)"'],
                                       this.layoutPreloadCssInclude.tablet,
                                       this.layoutCssTabletInclude
        );
        this.generateLayoutCSSTemplate([this.layoutCssMobile, this.importPathScssMobile],
                                       ["cssMobile", "importPathScssMobile"],
                                       this.cssMobile,
                                       this.scssMobile,
                                       [abstractFileVersion, cssMobileFilenameSuffix, 'media="screen and (max-width: 767px)"'],
                                       this.layoutPreloadCssInclude.mobile,
                                       this.layoutCssMobileInclude
        );
        this.generateLayoutHTMLTemplate(fontName);
        this.layoutTemplatesReady = true;
    }
}

export default ReleaseTemplateManager;